import { useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import { Sidebar } from './Sidebar';
import { Header } from './Header';
import { useAppDispatch } from '@/store/hooks';
import { establishOrgScope } from '@/store/auth/orgSessionSlice';

export function AppLayout() {
  const dispatch = useAppDispatch();

  // Self-heal a session restored from storage whose token predates org
  // scoping (no `orgId` claim): every org-scoped service would 403. The thunk
  // no-ops when the token is already scoped.
  useEffect(() => {
    void dispatch(establishOrgScope());
  }, [dispatch]);

  return (
    <div className="flex h-screen overflow-hidden bg-background">
      <Sidebar />
      <div className="flex flex-1 flex-col overflow-hidden">
        <Header />
        <main className="flex-1 overflow-y-auto p-6">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
